import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import CheckHistoryIcon from "../svgs/clock-history 1.svg";
import Tooltip from "@material-ui/core/Tooltip";
import format from "date-fns/format";
import "../report-styles/historyModal.scss";
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const HistoryModal = ({ uploadConfig, historyData }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    //setSelectedValue(value);
  };
  return (
    <div>
      <Tooltip title="History" placement="top">
        <img
          className="upload-icon"
          src={CheckHistoryIcon}
          onClick={handleClickOpen}
        />
      </Tooltip>
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
        maxWidth="md"
        className="upload-history-modal-container "
      >
        <h4>{uploadConfig.title}</h4>
        <div className="history-rows">
          <div className="history-row header">
            <div className="order-no">#</div>
            <div>
              <span>File name</span>
            </div>
            <div>Start time</div>
            <div>End time</div>
            <div className="center">Status</div>
          </div>
          {historyData.map((history, index) => (
            <div
              className="history-row"
              key={
                history.file_name +
                history.zone_aware_start_time +
                history.zone_aware_end_time
              }
            >
              {/* truncating large file name*/}
              <div className="order-no">{index + 1}.</div>
              <div>
                <Tooltip
                  arrow
                  title={
                    history.file_name && history.file_name.length > 17
                      ? history.file_name
                      : ""
                  }
                  placement="top-start"
                >
                  <span>
                    {history.file_name && history.file_name.length > 17
                      ? `${history.file_name.slice(0, 17)} ...`
                      : history.file_name}
                  </span>
                </Tooltip>
              </div>

              <div>
                {history.zone_aware_start_time
                  ? format(
                      new Date(history.zone_aware_start_time),
                      "dd MMM yyyy, h:mm a"
                    )
                  : "-"}
              </div>

              <div>
                {history.zone_aware_end_time
                  ? format(
                      new Date(history.zone_aware_end_time),
                      "dd MMM yyyy, h:mm a"
                    )
                  : "-"}
              </div>
              <div className={`center ${history.status}`}>
                {capitalizeFirstLetter(history.status)}
              </div>
            </div>
          ))}
        </div>
      </Dialog>
    </div>
  );
};

export default HistoryModal;
